import { FC } from "react";
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { EvaluationMetric } from "types/evaluationMetric";
import { getTargetAchievementTime } from "./constants";
import { getLabelLevel } from "pages/Requirements/config";
import { Requirement } from "../../types/requirement";
import { CustomLabel } from "types/CustomLabel";

type EvaluationMetricTableProps = {
  requirement: Requirement | null;
  evaluationMetrics: EvaluationMetric[];
  customLabels?: CustomLabel[];
};

export const EvaluationMetricTable: FC<EvaluationMetricTableProps> = ({
  requirement,
  evaluationMetrics,
  customLabels = [],
}) => {
  return (
    <>
      <TableContainer sx={{ display: { xs: "none", lg: "initial" } }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>Skill Level Score</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>
                Milestone Description
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }}>
                Target Achievement Time
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {evaluationMetrics.map((evaluationMetric) => (
              <TableRow key={evaluationMetric.evaluation_metric_id}>
                <TableCell scope="row">
                  <div>
                    {getLabelLevel(
                      requirement?.type || null,
                      evaluationMetric.skill_level,
                      customLabels,
                      evaluationMetric.skill_level_label,
                    )}
                  </div>
                </TableCell>
                <TableCell>
                  <div>{evaluationMetric.description}</div>
                </TableCell>
                <TableCell>
                  <div>
                    {getTargetAchievementTime(
                      requirement?.type || "",
                      evaluationMetric.target_achievement_time,
                      customLabels,
                    )}
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ display: { xs: "block", lg: "none" } }}>
        {evaluationMetrics.map((evaluationMetric) => (
          <Box key={evaluationMetric.evaluation_metric_id} my={1}>
            <Card
              key={evaluationMetric.evaluation_metric_id}
              sx={{
                p: 2,
                border: "1px solid rgba(0,0,0,0.2)",
                boxShadow: "none",
              }}
            >
              <Typography variant="body1">
                <Typography component={"span"} variant="body1" fontWeight={600}>
                  Skill Level Score:{" "}
                </Typography>
                {getLabelLevel(
                  requirement?.type || null,
                  evaluationMetric.skill_level,
                  customLabels,
                  evaluationMetric.skill_level_label,
                )}
              </Typography>

              <Typography variant="body1">
                <Typography component={"span"} variant="body1" fontWeight={600}>
                  Target Achievement Time:{" "}
                </Typography>
                {getTargetAchievementTime(
                  requirement?.type || "",
                  evaluationMetric.target_achievement_time,
                  customLabels,
                )}
              </Typography>

              <Typography variant="body1">
                <Typography component={"span"} variant="body1" fontWeight={600}>
                  Milestone Description: <br />
                </Typography>
                {evaluationMetric.description}
              </Typography>
            </Card>
          </Box>
        ))}
      </Box>
    </>
  );
};
